import { render } from "./TextCollapse.vue?vue&type=template&id=cd896212&scoped=true"
import script from "./TextCollapse.vue?vue&type=script&lang=js"
export * from "./TextCollapse.vue?vue&type=script&lang=js"

import "./TextCollapse.vue?vue&type=style&index=0&id=cd896212&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd896212"]])

export default __exports__